

 <template>
    <div>
        <el-input size="mini" disabled :value="value ? '已配置-审批流程' : '未配置-审批流程'" :class="[value ? 'is-success' : '']"> 
            <el-button slot="prepend" icon="el-icon-edit" @click="DialogOpen()">配置流程</el-button>
        </el-input>

        <el-dialog class="w-el-dialog" :visible.sync="dialogVisible" fullscreen append-to-body>

            
            <div slot="title">
                <i class="el-icon-guide"></i> 流程管理
            </div>

            
            <div class="wf">

                
                <workflow-cmpt-node :option.sync="workflow.value" :work="workflow.model" :showStart="true" />

                
                <div class="wf-end">
                    <div class="wf-end-box">
                        <div class="wf-end-circle"></div>
                        <div class="wf-end-text">流程结束</div>
                    </div>
                </div>
            </div>

            
            <div slot="footer">
                <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
                <el-button size="medium" @click="workflow.value = null">清空流程</el-button>
                <el-button size="medium" type="primary" @click="FlowUse()">应用流程</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import './cmpt.less'

export default {
    props: {
        value: {
            type: Object,
            default: null
        },
        model: {
            type: String,
            default: null
        },
        init: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            dialogVisible: false,

            workflow: {
                value: null,
                model: null
            },
        }
    },

    mounted() {
                if (this.init) {
            this.$http.post('/9api/workflow/template', { model: this.model } ).then(rps => {
                this.$emit('input', rps.data.template)
            })
        }
    },

    methods: {

        

        DialogOpen () {
            this.workflow.value = {...this.value}

                        this.workflow.model = this.model

                        if (this.value)
            {
                                this.workflow.value = {...this.value}
                this.dialogVisible = true

            }
            else {
                                this.$http.post('/9api/workflow/template', { model: this.model } ).then(rps => {
                    this.workflow.value = rps.data.template
                    this.dialogVisible = true
                })
            }
        },


        

        FlowUse() {
            this.$emit('input', this.workflow.value)
            this.$emit('onChang', this.workflow.value)
            this.dialogVisible = false
        },
    }
}
</script>

